// extracted by mini-css-extract-plugin
export var brandedReveal = "styles-module--brandedReveal--1uw_w";
export var chevron = "styles-module--chevron--2paVH";
export var heading = "styles-module--heading--3TLvq";